import React, { useContext, useMemo } from 'react';
import * as PropTypes from 'prop-types';

import Icon from '@components/icon';
import Link from '@components/link';
import Tooltip from '@components/tooltip';
import { classes } from 'as-ui-kit/utils/styles';

import {  DataContext } from 'contexts';
import { eventMetrics } from 'logic/requestParams';
import { useLocalized } from 'utils/useLocalized';

import i18nStrings from './strings';
import styles from './styles.modules.scss';
import {trucksUrl} from 'urls';

const ActualTrucks = ({atiId, trucksCount}) => {
    const strings = useLocalized(i18nStrings);
    const { searchResultsParams, isMobile, writeEvent } = useContext(DataContext);

    const url = useMemo(() => {
        const truckSearchUrl = new URL(`https:${trucksUrl}/?ExactFromGeos=true&ExactToGeos=true`);
        if (atiId) {
            truckSearchUrl.searchParams.set('FirmID', atiId);
        }
        if (searchResultsParams.truckType) {
            truckSearchUrl.searchParams.set('CarType', searchResultsParams.truckType);
        }
        if (searchResultsParams.from) {
            truckSearchUrl.searchParams.set('FromGeo', `${searchResultsParams.from.type}_${searchResultsParams.from.id}`);
        }
        if (searchResultsParams.to) {
            truckSearchUrl.searchParams.set('ToGeo', `${searchResultsParams.to.type}_${searchResultsParams.to.id}`);
        }
        if (searchResultsParams.truckWeight?.from) {
            truckSearchUrl.searchParams.set('Weight', searchResultsParams.truckWeight.from);
        }
        if (searchResultsParams.truckWeight?.to) {
            truckSearchUrl.searchParams.set('Weight2', searchResultsParams.truckWeight.to);
        }
        if (searchResultsParams.truckVolume?.from) {
            truckSearchUrl.searchParams.set('Volume', searchResultsParams.truckVolume.from);
        }
        if (searchResultsParams.truckVolume?.to) {
            truckSearchUrl.searchParams.set('Volume2', searchResultsParams.truckVolume.to);
        }

        return truckSearchUrl.toString();
    }, [searchResultsParams, atiId]);

    const linkContent = (
        <Link
            className={styles['link']}
            disabled={!atiId}
            href={url}
            preventDefault={false}
            rel="noopener"
            size="large"
            target="_blank"
            onClick={() => writeEvent(eventMetrics.openTransportSearch, [atiId])}
        >
            <div className={classes(styles['trucks'], !atiId && styles['disabled'])}>
                <Icon
                    color={!atiId ? '#8C969D' : '#478CC8'}
                    height={20}
                    name="ic_truck"
                    width={20}
                />
                <span>
                    {trucksCount}
                </span>
            </div>
        </Link>
    );

    return trucksCount === 0 ? '-'
        : isMobile
            ? linkContent : (
                <Tooltip
                    content={strings.trucksTooltip}
                    maxWidth={136}
                >
                    {linkContent}
                </Tooltip>
            );
};

export default ActualTrucks;

ActualTrucks.propTypes = {
    atiId: PropTypes.string,
    trucksCount: PropTypes.number
};
